<ng-container>
  <rfi-header [entity]="entity" [IsDbAdmin]="IsDbAdmin"></rfi-header>

  <aecom-tabs class="cusTab" [defaultTab]="defaultTab()">
    <aecom-tab title="details">
      <div style="overflow-y: auto; overflow-x: hidden">
        <rfi-detail
          [entity]="entity"
          [docs]="docs"
          [IsDbAdmin]="IsDbAdmin"
        ></rfi-detail>
      </div>
    </aecom-tab>
    @if (showProcessing) {
      <aecom-tab title="processing">
        <div style="overflow-y: auto; overflow-x: hidden">
          <rfiProcessingTab
            [entity]="entity"
            [docs]="docs"
            [allowMovingFiles]="allowMovingFiles()"
            (moveAttachment)="attachmentOut($event)"
            (moveAttachments)="attachmentsOut($event)"
          ></rfiProcessingTab>
        </div>
      </aecom-tab>
    }
    @if (showResponseTab) {
      <aecom-tab title="responses">
        <div style="overflow-y: auto; overflow-x: hidden">
          <rfiResponse-detail
            [isReviewer]="true"
            [showAddUserIcon]="isCompile"
            [turnOnNotifyUser]="isCompile"
            [rfiReviews]="reviewersResponse"
            [docs]="docs"
            [allowMovingFiles]="allowMovingFiles()"
            (moveAttachment)="attachmentOut($event)"
            (moveAttachments)="attachmentsOut($event)"
          ></rfiResponse-detail>
          <rfiResponse-detail
            [isReviewer]="false"
            [showAddUserIcon]="isCompile"
            [turnOnNotifyUser]="isCompile"
            [rfiReviews]="watchersResponse"
          ></rfiResponse-detail>
        </div>
      </aecom-tab>
    }
    <aecom-tab title="log">
      <div style="overflow-y: auto; overflow-x: hidden">
        <rfiLogTab
          [entity]="entity"
          [docs]="docs"
        ></rfiLogTab>
      </div>
    </aecom-tab>
  </aecom-tabs>
</ng-container>